// extracted by mini-css-extract-plugin
export default {"wrapperPadding":"HVACDashBoard_wrapperPadding__JDNO9"};